module.exports = __webpack_public_path__ + "static/use-case-5-content-3-f2f6a8e60c499fb485ca7bcfe0904a8f.png";